import React from 'react';
import { useAccount } from 'wagmi';
import { ExternalLink } from 'lucide-react';
import { NADFUN_TOKEN_URL } from '../../config/constants';

interface NadFunBuyButtonProps {
    className?: string;
    size?: 'sm' | 'md' | 'lg';
}

const NadFunBuyButton: React.FC<NadFunBuyButtonProps> = ({
    className = '',
    size = 'lg'
}) => {
    const { isConnected } = useAccount();

    const sizeClasses = {
        sm: 'nadfun-btn-sm',
        md: 'nadfun-btn-md',
        lg: 'nadfun-btn-lg',
    };

    const handleClick = () => {
        window.open(NADFUN_TOKEN_URL, '_blank', 'noopener,noreferrer');
    };

    return (
        <button
            onClick={handleClick}
            className={`nadfun-btn ${sizeClasses[size]} ${className}`}
            type="button"
        >
            <span className="nadfun-btn-content">
                <span className="nadfun-btn-icon">🦆</span>
                <span className="nadfun-btn-text">
                    {isConnected ? 'BUY $DUCK' : 'BUY ON NAD.FUN'}
                </span>
                <ExternalLink size={size === 'sm' ? 14 : size === 'md' ? 16 : 18} />
            </span>
            <span className="nadfun-btn-glow"></span>
            <span className="nadfun-btn-particles"></span>
        </button>
    );
};

export default NadFunBuyButton;
